import { render, staticRenderFns } from "./add-update-resource-action.vue?vue&type=template&id=a35d040c&scoped=true"
import script from "./add-update-resource-action.vue?vue&type=script&lang=js"
export * from "./add-update-resource-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35d040c",
  null
  
)

export default component.exports